import React from 'react'
import { Row, Col, Table } from 'react-bootstrap'
import moment from 'moment-timezone'
import {
  AwarenessSummaryResult,
  AssessmentPreviousResults,
  ABSpinner,
  AssessmentLoader,
  ModalProvider,
  CategoryModal,
  surveyType,
  AssessmentPdfDownload,
} from '@abroad/components'

const AwarenessAssessmentResult = ({
  isLoading = false,
  headerText,
  subHeaderText,
  subHeaderDescription,
  survey,
  clientId,
  isClientView = false,
  API,
  pdfTitle,
  pdfSubtitle,
  pdfFileNameBase,
}) => {
  const resolvedPdfTitle =
    pdfTitle || (typeof headerText === 'string' ? headerText : undefined)
  const resolvedPdfSubtitle =
    pdfSubtitle ||
    (typeof subHeaderText === 'string' ? subHeaderText : undefined)

  if (isLoading && !isClientView) {
    return <ABSpinner />
  }

  return (
    <main>
      <section className='custom-offset-lg-1 custom-col-lg-12 px-lg-0 abroad-fs-exclude wisdom-assessment'>
        <ModalProvider>
          {isClientView ? (
            <Row className='page-header mb-32px'>
              <Col>
                <div className='d-flex align-items-center'>
                  <h3 className='s1 tracking-normal mb-0 mt-3'>
                    Awareness Assessment
                    {!isLoading &&
                      survey?.createdAt &&
                      ` - ${moment(survey.createdAt).format('MMMM Do, YYYY')}`}
                  </h3>
                  {!isLoading && survey && (
                    <AssessmentPdfDownload
                      survey={survey}
                      assessmentType={surveyType.AWARENESS}
                      className='mt-3 ml-3'
                    />
                  )}
                </div>
              </Col>
            </Row>
          ) : (
            <Row className='page-header mb-32px'>
              <Col className='text-center'>
                <div className='d-flex justify-content-center align-items-center'>
                  <h3 className='s1 tracking-normal mb-0 mt-3'>{headerText}</h3>
                  {!isLoading && survey && (
                    <AssessmentPdfDownload
                      survey={survey}
                      assessmentType={surveyType.AWARENESS}
                      assessmentTitle={resolvedPdfTitle}
                      assessmentSubtitle={resolvedPdfSubtitle}
                      fileNameBase={pdfFileNameBase}
                      className='mt-3 ml-3'
                    />
                  )}
                </div>
                {subHeaderText && (
                  <>
                    <h4 className='s4 mt-3 mb-0'>{subHeaderText}</h4>
                    <p className='s5 d-flex justify-content-center mt-3 mb-0'>
                      <span className='w-100 w-lg-7/12'>
                        {subHeaderDescription}
                      </span>
                    </p>
                  </>
                )}
              </Col>
            </Row>
          )}
          {isLoading && isClientView ? (
            <AssessmentLoader />
          ) : (
            <>
              <AwarenessSummaryResult
                survey={survey}
                showCategoryAudio={isClientView}
                isRenderOnAdmin
              />
              {clientId ? (
                <div>
                  <Row className='mb-3'>
                    <Col>
                      <h3 className='s2 mb-0'>Assessment User</h3>
                    </Col>
                  </Row>
                  <Table
                    hover
                    responsive
                    className='custom-table assessment-users-table'>
                    <thead>
                      <tr>
                        <th width='20%'>Full Name</th>
                        <th width='20%'>Survey Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{survey?.fullName}</td>
                        <td className='text-capitalize'>
                          {survey?.surveyType}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  {API && (
                    <AssessmentPreviousResults
                      API={API}
                      isRenderOnAdmin
                      surveyType={surveyType.AWARENESS}
                      clientId={clientId}
                    />
                  )}
                </div>
              ) : (
                <div>
                  <Row className='mb-3'>
                    <Col>
                      <h3 className='s2 mb-0'>Assessment Users</h3>
                    </Col>
                  </Row>
                  <Table
                    hover
                    responsive
                    className='custom-table assessment-users-table'>
                    <thead>
                      <tr>
                        <th width='5%'>#</th>
                        <th width='10%'>Full Name</th>
                        <th width='20%'>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {survey?.users?.length > 0 ? (
                        survey.users.map((user, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{user.fullName}</td>
                            <td>{user.email}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan='3' className='text-center'>
                            Assessment users not available at this moment.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </>
          )}
          <CategoryModal />
        </ModalProvider>
      </section>
    </main>
  )
}

export default AwarenessAssessmentResult
